module.exports = __webpack_public_path__ + "static/img/bcg.84bcab11.png";